<mat-sidenav-container>
  <app-header [appTitle]="'DASHBOARD.APP_TITLE' | translate"></app-header>
  <xng-breadcrumb [separator]="iconTemplate" *ngIf="showBreadCrumb">
    <ng-container
      *xngBreadcrumbItem="let breadcrumb; let info = info; let first = first"
    >
      <ng-container *ngIf="!first">
        <div *ngIf="first">Home</div>
        <ng-container>{{ breadcrumb }}</ng-container>
      </ng-container>
    </ng-container>
  </xng-breadcrumb>
  <ng-template #iconTemplate>
    <i class="fas fa-chevron-right"></i>
  </ng-template>

  <mat-sidenav
    mode="side"
    [opened]="auth.navOpen"
    fixedInViewport="true"
    *ngIf="auth.loggedIn"
    class="custom-sidenav-class"
  >
    <app-sidenav></app-sidenav>
  </mat-sidenav>
  <router-outlet></router-outlet>
</mat-sidenav-container>

<!-- AI Panel Component - Outside mat-sidenav-container for proper fixed positioning -->
<ng-container *ngIf="auth.loggedIn">
  <!-- The AI agent (button + panel + its usage calls) only mounts for a role that can use AI.
       Without ai.use it isn't shown at all — no launcher, no 401s from the token-usage endpoints. -->
  <app-ai-panel *hasPermission="'ai.use'"></app-ai-panel>
</ng-container>
<!--<ngx-panel-container></ngx-panel-container>-->
